import { render, staticRenderFns } from "./QuickAccessMenu.vue?vue&type=template&id=1b0e8799&scoped=true"
import script from "./QuickAccessMenu.vue?vue&type=script&lang=js"
export * from "./QuickAccessMenu.vue?vue&type=script&lang=js"
import style0 from "./QuickAccessMenu.vue?vue&type=style&index=0&id=1b0e8799&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e8799",
  null
  
)

export default component.exports